module.exports = __webpack_public_path__ + "static/assets/4901090d1df378dc333fab656582c5b9.png";